import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import {
  configPropertyDeclaration,
  type WiredElement,
} from '@adornis/prosemirror-editor/prosemirror-helpers/configNodeView.js';
import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { BHBuildifyFlexConfiguration } from './configuration.js';

webcomponent(
  'node-flex',
  (self: WiredElement<BHBuildifyFlexConfiguration>) => {
    const config = self.config;
    return html`
      <div
        style=${styleMap({
          display: 'flex',
          flexDirection: config?.flexDirection ?? 'column',
          rowGap: config?.rowGap,
          columnGap: config?.columnGap,
          justifyContent: config?.justifyContent,
          alignItems: config?.alignItems,
          backgroundColor: config?.backgroundColor,
          borderRadius: config?.borderRadius,
          height: config?.height,
          padding: config?.padding,
          margin: config?.margin,
        })}
      >
        <slot style="display: contents"></slot>
      </div>
    `;
  },
  {
    shadowRoot: true,
    properties: { config: configPropertyDeclaration(BHBuildifyFlexConfiguration) },
    styles: { ':host': { display: 'block', whiteSpace: 'normal' } },
  },
);
